import { createContext } from "react";

const UserSettingsContext = createContext({
  units: 'kg',
  setUnits: () => {}
});
export default UserSettingsContext;
